import { DEFAULT_GATEWAY_USER_SETTINGS } from './const/defaultGatewayUserSettings.const'
import { GATEWAY_USER_SETTINGS_STORAGE_KEY } from './const/gatewayUserSettingsStorageKey.const'
import type { GatewayUserSettings } from './interfaces/gatewayUserSettings.interface'
import { isValidGatewayPort } from './isValidGatewayPort'

const isGatewayUserSettings = (value: unknown): value is GatewayUserSettings => {
  if (typeof value !== 'object' || value === null) {
    return false
  }

  const settings = value as GatewayUserSettings
  return typeof settings.useCustom === 'boolean'
}

const isValidCustomSettings = (settings: GatewayUserSettings): boolean => {
  if (!settings.host?.trim()) {
    return false
  }

  if (!settings.httpPort?.trim() || !isValidGatewayPort(settings.httpPort)) {
    return false
  }

  if (settings.wsPort?.trim() && !isValidGatewayPort(settings.wsPort)) {
    return false
  }

  if (settings.mcpPort?.trim() && !isValidGatewayPort(settings.mcpPort)) {
    return false
  }

  return true
}

export function loadGatewayUserSettings(): GatewayUserSettings {
  if (typeof window === 'undefined') {
    return DEFAULT_GATEWAY_USER_SETTINGS
  }

  try {
    const stored = localStorage.getItem(GATEWAY_USER_SETTINGS_STORAGE_KEY)
    if (!stored) {
      return DEFAULT_GATEWAY_USER_SETTINGS
    }

    const parsed: unknown = JSON.parse(stored)
    if (!isGatewayUserSettings(parsed)) {
      return DEFAULT_GATEWAY_USER_SETTINGS
    }

    const settings: GatewayUserSettings = {
      useCustom: parsed.useCustom,
      host: parsed.host?.trim() || undefined,
      httpPort: parsed.httpPort?.trim() || undefined,
      wsPort: parsed.wsPort?.trim() || undefined,
      mcpPort: parsed.mcpPort?.trim() || undefined,
    }

    if (settings.useCustom && !isValidCustomSettings(settings)) {
      return DEFAULT_GATEWAY_USER_SETTINGS
    }

    return settings
  } catch {
    return DEFAULT_GATEWAY_USER_SETTINGS
  }
}
